const config = {
	appDomain: 'https://client-staging.kellypartners.com',
	apiDomain: 'https://api-staging.kellypartners.com/',
	blobStorageRootUrl: 'https://kpclientsstaging.blob.core.windows.net/',
	iPracticeRootUrl: 'https://beta.ipracticehub.com/',
	environment: 'staging',
	title: 'Staging',
	currentCulture: 'en-AU',
	stripePublishableKey:
		'pk_test_51NLK97ItboXz9npVH6G4nuUnjNnr3wwPGa2VjksWggTGG9zV4EZsjYfHeE280Wdlwh02yV1uLtvkZdKxmklpGV4R0040rS8GL9',
	appName: 'Kelly+Partners Passport',
	autoLogoutTimeoutInMs: 1800000
};

export type Config = typeof config;

export default config;
